import { Request } from "./HttpService";

export const TablesService = {
  getTableByName(tableName) {
    return Request(`vitae/table/GetColumnsByTableName/${tableName}`, "GET");
  },
  getUserTableColumns(tableName) {
    return Request(`vitae/table/${tableName}`, "GET");
  },
  saveUserTableColumns(data, tableName) {
    return Request(`vitae/table/${tableName}`, "POST", data);
  },
  resetUserTableColumns(tableName) {
    return Request(`vitae/table/${tableName}`, "DELETE");
  }
};
